import React from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { UserIcon } from '../../../../components/IconsSVG';
import AdminDropdown from '../../../../partials/content/CustomDropdowns/AdminDropdown';
import CrudActions from '../../../../partials/datatable/CrudActions';
import Datatable from '../../../../partials/datatable/Datatable';
import { StyledTableCell, StyledTableRow } from '../../../../partials/datatable/styles';
import { MutantApiService } from '../../../../services/MutantApiService';
import store from '../../../../store/store';
import Loading from '../../../home/components/Loading';
import { format } from 'date-fns';

const initialState = {
	users: [],
	reload: false,
	loading: true,
};

export default class UsersListing extends React.Component {
	constructor(props) {
		super(props);
		const { auth } = store.getState();

		this.api = new MutantApiService();

		this.state = {
			...initialState,
			userLogged: auth.user,
		};

		this.handleConfirmChangeStatus = this.handleConfirmChangeStatus.bind(this);
		this.formatRow = this.formatRow.bind(this);
		this.setUsers = this.setUsers.bind(this);
	}

	componentDidMount() {
		this.setState({ loading: false });
	}

	handleConfirmChangeStatus = async function (obj) {
		try {
			await this.setState({ loading: true });

			await this.api.makeHttpRequest({
				method: 'PUT',
				url: `/user/${obj.id}`,
			});

			await this.setState({ loading: false });

			await Swal.fire({
				title: 'Sucesso!',
				text: 'Status alterado com sucesso.',
				icon: 'success',
				cancelButtonText: 'Sair',
			});
		} catch (e) {
			await this.setState({ loading: false });
			await Swal.fire('Erro!', 'Erro ao alterar status.', 'error');
		} finally {
			await this.setState({ reload: !this.state.reload });
		}
	};

	setUsers = (users) => {
		this.setState({ users });
	};

	handleConfirmDelete = async (id) => {
		try {
			const reqBase = { method: "DELETE", url: `/users/${id}/` }

			await this.api.makeHttpRequest(reqBase);
			await this.setState({ reload: !this.state.reload });
		} catch (e) {
			await Swal.fire(
				"Erro",
				"Problema ao reverter as alterações, tente mais tarde",
				"error"
			);
		}
	}

	formatRow = (user) => {
		const crudActions = ['edit'];
		const disabledEmails = [
			'blackbolt.manager@mutant.com',
			'blackbolt.admin@mutant.com',
			'blackbolt.user@mutant.com',
		]

		return (
			<StyledTableRow hover tabIndex={-1} key={user.id}>
				<StyledTableCell scope="row" align="left" width="25%">
					{!!user.firstName && `${user.firstName} ${user.lastName}`}
				</StyledTableCell>
				<StyledTableCell scope="row" align="left" width="25%">
					{user.email}
				</StyledTableCell>
				<StyledTableCell scope="row" align="center" width="20%">
					{!!user.role && `${user.role}`}
				</StyledTableCell>
				<StyledTableCell scope="row" align="left" width="20%">
					{!!user.createdAt && format(new Date(user.createdAt), 'dd/MM/yyyy hh:mm')}
				</StyledTableCell>
				<StyledTableCell scope="row" width="10%" align="center">
					<CrudActions
						actions={crudActions}
						module="users"
						id={user.id}
						onConfirmChangeStatus={this.handleConfirmChangeStatus}
						onConfirmDelete={this.handleConfirmDelete}
						disabledEmails={disabledEmails}
						obj={user}
					/>
				</StyledTableCell>
			</StyledTableRow>
		);
	};

	render() {
		window.setPageTitle('Listagem de projetos');

		const headRows = [
			{ label: 'NOME', align: "left" },
			{ label: 'EMAIL', align: "left" },
			{ label: 'Perfil', align: "center" },
			{ label: 'DATA DE CRIAÇÃO', align: "left" },
			{ label: 'AÇÕES', align: 'center' },
		];

		return (
			<>
				<Loading isLoading={this.state.loading} />
				<Datatable
					title="Usuários"
					icon={UserIcon}
					endpoint="user"
					className="h-100"
					headRows={headRows}
					formatRow={this.formatRow}
					rows={this.state.users}
					clietsRows={this.state.clients}
					setRows={this.setUsers}
					reload={this.state.reload}
					placeholderSearch="Filtre por nome"
					mobile={AdminDropdown}
					width={this.props.width}
					hiddenReload
					users
					buttons={[
						{
							label: "Adicionar",
							onClick: null,
							icone: "add",
							path: "/dashboard/users/new"
						}
					]}
				/>
			</>
		);
	}
}
